import React from "react";
import { Card, Container, Row, Col, Spacer } from "@cleartrip/bento";
import { MONTHS, AM_PM, WEEKDAYS } from "../../../constants/ArabicDate";
import { langTranslate } from 'helper/arabic';

function TopBanner(props) {
  let { timeStamp = '', content = [], align = () => "ltr" } = props;

  return (
    <Card className="py-4 bg-warning-100 py-2--xs">
      <Container>
        <Row>
          <Col className="flex flex-between flex-middle flex-wrap">
            <div className="d-none d-block--xs w-100p--xs pr-0--xs pr-4">
              {content.map((listItem, idx) => (
                <>
                  <p className="fs-3 c-neutral-700 fw-500">{listItem}</p>
                  {content.length - 1 != idx && <Spacer className="pt-1" />}
                </>
              ))}
            </div>

            <div className="d-none--xs flex-1 w-100p--xs pr-0--xs pr-4">
              {content.map((listItem, idx) => (
                <>
                  <p className="fs-3 c-neutral-700 fw-500">{listItem}</p>
                  {content.length - 1 != idx && <Spacer className="pt-1" />}
                </>
              ))}
            </div>
            <p className="fs-3 c-neutral-700 fw-500 pt-2--xs pt-0">
              {langTranslate('Page last updated')}: {timeStamp}
            </p>
          </Col>
        </Row>
      </Container>
    </Card>
  );
}

export default TopBanner;
